import React from "react";

interface ScheduledDeletionCanceledModalProps {
  onClose: () => void;
}

const ScheduledDeletionCanceledModal: React.FC<
  ScheduledDeletionCanceledModalProps
> = ({ onClose }) => {
  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      onClick={onClose}
    >
      <div
        className="bg-white dark:bg-gray-800 rounded-lg shadow-xl"
        style={{ width: "500px", height: "400px" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="h-full flex flex-col items-center justify-center p-8">
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-6 text-center">
            Account Restored!
          </h2>
          <p className="text-gray-700 dark:text-gray-300 mb-8 text-center leading-relaxed">
            Your account had been marked for deletion. By logging in we've
            canceled that pending deletion and restored your account and
            inboxes. You can delete your account again from settings, or reach
            out if you need any help!
          </p>
          <button
            onClick={onClose}
            className="px-8 py-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            Got it!
          </button>
        </div>
      </div>
    </div>
  );
};

export default ScheduledDeletionCanceledModal;
